var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeterinaryPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.29,
    y: 58.41,
    width: 222.11,
    height: 146.28,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.08,93.36S61,91.64,59,93.75c-.7.75-.88,3.21,1.86,3.7,0,0,5.93-.32,8.63-.81s8.84-3.2,8.84-3.2l3.19-7.11s.41-3.36.82-3.44S84,86.33,84,86.33l6.88,2,.73,1.39L86,92s.82,8.84.08,10.39a14.45,14.45,0,0,1-2.86,3.44l.32,12.85s1.23-.49,1.31.41H81.59s-1.31-8-3.19-8.6l.49-3.35L66,106.05s.9,3-2.78,5.48A26.51,26.51,0,0,0,57.94,116v2.45s1.07.41,1.15,1.31H55.16s.49-6.79,0-7.94c0,0,4.82-4.92,4.17-11,0,0-5.48-1.39-4.17-6.71S62.61,88.7,64.08,93.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9,134.32s-1.93-1.06-3.16.25a1.45,1.45,0,0,0,1.15,2.3s3.69-.21,5.36-.51a38.87,38.87,0,0,0,5.5-2l2-4.42s.25-2.08.51-2.14,1,2.14,1,2.14l4.28,1.22L82,132l-3.45,1.43s.5,5.49,0,6.46a9.08,9.08,0,0,1-1.78,2.13l.2,8s.76-.31.81.25h-2s-.81-5-2-5.34l.3-2.08-8-.67s.56,1.89-1.73,3.41a16.72,16.72,0,0,0-3.31,2.75v1.52s.66.26.72.82H59.36s.3-4.22,0-4.94c0,0,3-3.06,2.59-6.81,0,0-3.41-.86-2.59-4.17S64,131.42,64.9,134.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,168.32s-1.46-.8-2.38.19a1.09,1.09,0,0,0,.87,1.73s2.77-.16,4-.39a29,29,0,0,0,4.13-1.49l1.5-3.33s.19-1.57.38-1.61.77,1.61.77,1.61L76,166l.34.65-2.6,1.07s.38,4.14,0,4.87a6.69,6.69,0,0,1-1.34,1.6l.16,6s.57-.23.61.19H71.7s-.62-3.75-1.5-4l.23-1.57-6-.5a2.41,2.41,0,0,1-1.3,2.57,12.44,12.44,0,0,0-2.49,2.06V180s.49.2.53.62H59.32a19.86,19.86,0,0,0,0-3.72,7.19,7.19,0,0,0,2-5.13,2.59,2.59,0,0,1-2-3.14C59.94,166.18,62.81,166.14,63.5,168.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,99.11c0,.14-23.09.26-51.58.26s-51.58-.12-51.58-.26,23.09-.26,51.58-.26S217.83,99,217.83,99.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,103.09c0,.14-23.09.26-51.58.26s-51.58-.12-51.58-.26,23.09-.26,51.58-.26S217.83,102.94,217.83,103.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,107.06c0,.15-23.09.26-51.58.26s-51.58-.11-51.58-.26,23.09-.26,51.58-.26S217.83,106.92,217.83,107.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,111c0,.15-23.09.26-51.58.26s-51.58-.11-51.58-.26,23.09-.26,51.58-.26S217.83,110.9,217.83,111Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,133.58c0,.15-23.09.26-51.58.26s-51.58-.11-51.58-.26,23.09-.26,51.58-.26S217.83,133.44,217.83,133.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,137.56c0,.15-23.09.26-51.58.26s-51.58-.11-51.58-.26,23.09-.26,51.58-.26S217.83,137.42,217.83,137.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,141.54c0,.14-23.09.26-51.58.26s-51.58-.12-51.58-.26,23.09-.26,51.58-.26S217.83,141.4,217.83,141.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,145.52c0,.14-23.09.26-51.58.26s-51.58-.12-51.58-.26,23.09-.26,51.58-.26S217.83,145.37,217.83,145.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,168.06c0,.14-23.09.26-51.58.26s-51.58-.12-51.58-.26,23.09-.26,51.58-.26S217.83,167.92,217.83,168.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,172c0,.14-23.09.26-51.58.26s-51.58-.12-51.58-.26,23.09-.26,51.58-.26S217.83,171.89,217.83,172Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,176c0,.14-23.09.26-51.58.26s-51.58-.12-51.58-.26,23.09-.26,51.58-.26S217.83,175.87,217.83,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,180c0,.15-23.09.26-51.58.26s-51.58-.11-51.58-.26,23.09-.26,51.58-.26S217.83,179.85,217.83,180Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,79.25c0,1.44-22.92,2.61-51.18,2.61s-51.19-1.17-51.19-2.61,22.91-2.6,51.19-2.6S208.69,77.81,208.69,79.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.53,55.11h-2.81V49.79a3,3,0,0,0-2.78-3.12H350.55a3,3,0,0,0-2.77,3.12v5.32H345V49.79a5.78,5.78,0,0,1,5.58-5.94h21.39a5.78,5.78,0,0,1,5.59,5.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.69,
    y: 55.11,
    width: 110.69,
    height: 74.01,
    rx: 9.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.93,
    y: 77.17,
    width: 6.64,
    height: 29.75,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.93,
    y: 77.17,
    width: 6.64,
    height: 29.75,
    transform: "translate(269.2 453.3) rotate(-90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,92.12s0-.14,0-.4-.05-.68-.09-1.18c0-.26,0-.55-.05-.86s-.11-.66-.17-1a17.78,17.78,0,0,0-.52-2.55,23.5,23.5,0,0,0-2.76-6.56,24.76,24.76,0,0,0-32.73-9.06,26,26,0,0,0-3,1.93,28.11,28.11,0,0,0-2.78,2.37,27.28,27.28,0,0,0-2.4,2.84,23.88,23.88,0,0,0-3.51,6.76,24.25,24.25,0,0,0,0,15.49,23.72,23.72,0,0,0,3.5,6.76,28.79,28.79,0,0,0,2.41,2.85,28.31,28.31,0,0,0,2.78,2.37,26,26,0,0,0,3,1.93,25.74,25.74,0,0,0,3.2,1.41,24.67,24.67,0,0,0,12.91,1.08,24.73,24.73,0,0,0,16.62-11.55,23.5,23.5,0,0,0,2.76-6.56,17.78,17.78,0,0,0,.52-2.55c.06-.38.13-.72.17-1s0-.6.05-.86c0-.5.07-.89.09-1.18s0-.4,0-.4a1.55,1.55,0,0,1,0,.4c0,.29,0,.68,0,1.18q0,.4,0,.87c0,.32-.09.67-.14,1.05a19.24,19.24,0,0,1-.48,2.58,24,24,0,0,1-2.7,6.66,25,25,0,0,1-16.8,11.83,25.14,25.14,0,0,1-13.15-1,26.14,26.14,0,0,1-3.27-1.43,27.19,27.19,0,0,1-3.08-2,29.2,29.2,0,0,1-2.84-2.41,28.53,28.53,0,0,1-2.46-2.9,24.28,24.28,0,0,1-3.59-6.91,26.46,26.46,0,0,1-1.29-7.9,26.85,26.85,0,0,1,1.29-7.91,24.61,24.61,0,0,1,3.59-6.9,28.73,28.73,0,0,1,2.46-2.9A28.17,28.17,0,0,1,346.29,72a25,25,0,0,1,3.07-2,26.14,26.14,0,0,1,3.27-1.43,25.11,25.11,0,0,1,13.14-1,25,25,0,0,1,16.81,11.83,24,24,0,0,1,2.7,6.66,19,19,0,0,1,.48,2.58c.05.38.11.72.14,1s0,.61,0,.88c0,.49,0,.89,0,1.18A1.55,1.55,0,0,1,386,92.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.5,60.56V49.37h-7.87V60.56h-7.92v64h23.15v-64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.94,
    y: 124.57,
    width: 190.96,
    height: 9.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.26,
    y: 134.32,
    width: 5.56,
    height: 23.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.44,
    y: 134.32,
    width: 5.56,
    height: 23.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.44,77.78V69.6h-5.76v8.18h-5.79v46.79h16.92V77.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.64,77.78V69.6h-5.75v8.18H414.1v46.79H431V77.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.86,
    y: 94.17,
    width: 30.4,
    height: 30.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.11,102c0,.2-6.71.36-15,.36s-15-.16-15-.36,6.71-.35,15-.35S330.11,101.79,330.11,102Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.21,106s.11,0,.31.05a2.65,2.65,0,0,1,.81.38,4.36,4.36,0,0,1,1.67,2.8,6.34,6.34,0,0,1-.79,4.78,4.45,4.45,0,0,1-2.36,1.79,5.76,5.76,0,0,1-3.16,0,5.6,5.6,0,0,1-4.22-4.07,4.83,4.83,0,0,1,1.43-4.59,4.75,4.75,0,0,1,3-1.23,2.07,2.07,0,0,1,1.18.2c0,.06-.43,0-1.15.08a4.81,4.81,0,0,0-2.71,1.31,4.35,4.35,0,0,0-1.13,4.09,5.57,5.57,0,0,0,6.54,3.57,3.81,3.81,0,0,0,2-1.5,6,6,0,0,0,.82-4.31,4.28,4.28,0,0,0-1.34-2.67C316.61,106.18,316.19,106.06,316.21,106Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.08,347.31c-6.37-3.28-13.86-3.71-20.93-2.54-3.8.63-7.76,1.76-10.35,4.61s-3.07,7.88-.1,10.33c1.76,1.46,4.23,1.68,6.52,1.65,5.53-.06,11.67-1,16.1,2.29,2.52,1.9,4.2,5.06,7.21,6s6.28-.83,7.85-3.49a12.23,12.23,0,0,0,.89-9A13.73,13.73,0,0,0,47.08,347.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,319.15c-3.89,5.56-11.46,3.72-15,.32s-5-8.31-6.34-13c-3.09-10.72-6.2-22-3.9-32.89a18.22,18.22,0,0,1,4.2-8.94c2.29-2.42,5.82-3.86,9-3,3.82,1,6.19,4.75,7.9,8.3a78.42,78.42,0,0,1,7.75,33.64c0,5.42-.62,11.1-3.68,15.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.37,327.13c-4.23-5-5-12.34-3.15-18.63s6.13-11.63,11-16A59.43,59.43,0,0,1,100,280.85a21.07,21.07,0,0,1,8.88-1.51c3,.29,6.05,1.83,7.45,4.51,2.08,4,.09,8.78-2.07,12.7a149,149,0,0,1-13,19.75c-3.89,5-8.34,10-14.27,12.23s-12.08,2-15.22-2.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.94,403a10.94,10.94,0,0,1-.36-2.53c-.18-1.83-.4-4.14-.67-6.89a98.27,98.27,0,0,0-1.55-10.12,77.16,77.16,0,0,0-3.68-11.94,44,44,0,0,0-6.09-10.8,22.83,22.83,0,0,0-7.71-6.41,21.67,21.67,0,0,0-6.49-2,13.06,13.06,0,0,1-2.52-.36,10.81,10.81,0,0,1,2.56,0,19.38,19.38,0,0,1,6.77,1.76,22.72,22.72,0,0,1,8.13,6.46,42.72,42.72,0,0,1,6.32,11,72.53,72.53,0,0,1,3.65,12.14,84.53,84.53,0,0,1,1.35,10.24c.22,2.93.3,5.3.34,6.94A11.76,11.76,0,0,1,61.94,403Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.46,397.74a4.8,4.8,0,0,1-.07-1.18c0-.88,0-2,0-3.35,0-2.91,0-7.12-.15-12.32-.26-10.4-1.15-21.6-2.88-37.38-1.64-14.84-3.84-32.11-6.16-43.33-.49-2.56-1-4.86-1.47-6.87s-.83-3.75-1.2-5.16-.58-2.4-.78-3.26a5.47,5.47,0,0,1-.21-1.16,5.68,5.68,0,0,1,.41,1.1c.25.85.58,1.91,1,3.22s.88,3.12,1.38,5.13,1.08,4.29,1.62,6.84a380.7,380.7,0,0,1,6.48,40.21c1.73,15.82,2.51,30.22,2.58,40.64.06,5.22-.05,9.44-.18,12.35-.09,1.36-.15,2.47-.21,3.35A4.94,4.94,0,0,1,61.46,397.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.39,370a22.26,22.26,0,0,1,0-3.5A92.68,92.68,0,0,1,62.49,357a125.56,125.56,0,0,1,3.08-13.83,114.21,114.21,0,0,1,5.79-16.36c4.79-11.37,11.31-20.68,17-26.44a43.41,43.41,0,0,1,4-3.71c.61-.52,1.16-1,1.71-1.45l1.55-1.06a21.47,21.47,0,0,1,3-1.89c.16.23-4.18,2.78-9.67,8.62A91.92,91.92,0,0,0,72.31,327.2a129,129,0,0,0-5.81,16.21,139,139,0,0,0-3.28,13.69c-.73,3.94-1.15,7.16-1.4,9.39A22.73,22.73,0,0,1,61.39,370Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 418.95 85.45 457.08 36.47 457.08 33.69 418.95 88.23 418.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.85,
    y: 403.93,
    width: 65.12,
    height: 15.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.96 455.62 92.96 459.78 89.91 459.78 28.92 459.78 28.92 455.62 92.96 455.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.91 467.11 89.91 459.78 31.26 459.78 34.76 467.11 86.91 467.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,431.41a1.69,1.69,0,0,0,.23.35l.73,1,2.85,3.65.13.17.12-.17c1.8-2.48,4.19-5.8,7-9.7h-.4l6.9,9.77.22.31.24-.29,8.18-9.74h-.47l.45.56,7.32,9.18.24.3.23-.31c2.48-3.52,4.81-6.8,6.9-9.77l-.4,0,8.51,9.68.15.18.11-.2c1.12-1.88,2-3.38,2.66-4.47l.69-1.19a2,2,0,0,0,.21-.43,1.94,1.94,0,0,0-.29.38c-.2.3-.45.68-.75,1.15l-2.8,4.39.27,0-8.37-9.81-.21-.25-.19.27-7,9.73.47,0c-2.32-2.91-4.77-6-7.3-9.19l-.45-.56-.23-.29-.24.28-8.17,9.76.46,0c-2.52-3.52-4.86-6.79-7-9.72l-.2-.29-.2.29-6.86,9.8h.25l-3-3.56c-.32-.37-.58-.68-.8-.92S34.61,431.4,34.6,431.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,418.7c0,.17,12.27.31,27.41.31s27.41-.14,27.41-.31-12.27-.3-27.41-.3S33,418.53,33,418.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.54,460.19c0,.17,13.33.31,29.78.31s29.79-.14,29.79-.31-13.33-.3-29.79-.3S30.54,460,30.54,460.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.76,
    y: 170.08,
    width: 92.35,
    height: 96.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.51,
    y: 170.08,
    width: 92.35,
    height: 96.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.92,
    y: 183.02,
    width: 67.52,
    height: 70.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.92,253.87a11.83,11.83,0,0,1-1.68,1.92c-1.09,1.13-2.61,2.67-4.3,4.34s-3.26,3.17-4.41,4.23A11.89,11.89,0,0,1,362.6,266a12.92,12.92,0,0,1,1.68-1.9c1.09-1.14,2.61-2.68,4.31-4.35s3.27-3.18,4.41-4.24A13.32,13.32,0,0,1,374.92,253.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.45,253.7a14,14,0,0,1,1.91,1.69c1.13,1.08,2.67,2.6,4.34,4.3s3.17,3.26,4.24,4.4a13.18,13.18,0,0,1,1.65,1.93,11.94,11.94,0,0,1-1.91-1.68c-1.13-1.08-2.67-2.6-4.35-4.31s-3.18-3.26-4.24-4.41A12.35,12.35,0,0,1,442.45,253.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.26,183.21a13.64,13.64,0,0,1,1.69-1.92c1.09-1.13,2.6-2.67,4.3-4.34s3.26-3.17,4.41-4.23a11.89,11.89,0,0,1,1.93-1.65,14.09,14.09,0,0,1-1.68,1.91c-1.09,1.13-2.61,2.67-4.31,4.35s-3.27,3.17-4.41,4.23A12.42,12.42,0,0,1,442.26,183.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.74,183.38a13.15,13.15,0,0,1-1.91-1.69c-1.14-1.08-2.67-2.6-4.35-4.3s-3.16-3.26-4.23-4.4a13.18,13.18,0,0,1-1.65-1.93,11.94,11.94,0,0,1,1.91,1.68c1.13,1.08,2.67,2.6,4.35,4.31s3.17,3.26,4.24,4.41A12.35,12.35,0,0,1,374.74,183.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.26,253.41s0-.12,0-.34,0-.56,0-1c0-.88,0-2.15,0-3.8,0-3.33,0-8.18,0-14.34,0-12.33-.07-29.89-.12-50.93l.22.22-67.33,0h0l.26-.25c0,25.83,0,50,0,70.39l-.22-.22,48.77.11,13.7.06,3.62,0h.93l.32,0h-1.21l-3.57,0-13.65,0-48.91.11h-.21v-.21c0-20.39,0-44.56,0-70.39v-.26h.26l67.33,0h.23V183c0,21.09-.08,38.71-.11,51.07,0,6.14,0,11-.06,14.29,0,1.63,0,2.89,0,3.76,0,.41,0,.72,0,1S442.26,253.41,442.26,253.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.75,212.42s-1.45,17.43,17.42,17.43C410.17,220.55,402.5,213.21,392.75,212.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.28,212.44s-17.43-1.45-17.43,17.42C419.15,229.86,426.49,222.19,427.28,212.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.34,202.9s-14.24,12.78.78,26.95C417.1,222.45,416.51,210.85,409.34,202.9Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.14,467.23c0,.15-94.83.26-211.78.26s-211.81-.11-211.81-.26,94.81-.26,211.81-.26S462.14,467.09,462.14,467.23Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.77,297.15s-20.15-3.16-21.83-3.1-17.66,3.19-17.66,3.19-22.61,4-24.89,5.64-.6,6.79-.6,6.79c2.51,1,10.42-.57,10.42-.57a11.9,11.9,0,0,0,1.38,5c1.42,2.86,5.3,2.14,5.3,2.14l-3,1.56a24.47,24.47,0,0,0,1.36,5.3c1.1,3,8.31,2.57,8.31,2.57s1.9,4.28,4.89,5,18.55-2.93,23.17-3.43,13.48-6,13.48-6a108.05,108.05,0,0,0,10.87,3.23l2.27-29.36C222.54,295,210.77,297.15,210.77,297.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,390.27c-8.59-2.16-15.09-9.67-18-18s-2.84-17.47-2-26.28a8.91,8.91,0,0,0-.39-4.87c-1.15-2.36-4.31-3.18-6.82-2.4s-4.44,2.76-6,4.83a37.44,37.44,0,0,0,32.5,60.24",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.12,307.37s20.13,34.87,25.22,48.89,11.57,52.57,11.57,52.57,30.22,7.78,11.5,40.28c-6.92,12-6.3,17.58-14.06,17.94-6,.27-54.72-.1-54.72-.1l.88,4.77s-4.08,13.78-12.32,9.89-18-14.66-18-14.66l-14.17-.19L97.29,467l-9.87-.19,0-.27a14,14,0,0,1,9.81-11.65l7.24-2.2s-9.41-39.52-1.26-49,21.41-8.83,21.41-8.83l-6.09-40.67a63.77,63.77,0,0,1,2.81-28.33l4.57-13.59Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.17,396.22c14,7.93,23.38,21.22,28.07,36.4,0,.16.29.09.24-.06-3.63-11.77-10.08-22.67-19.59-30.63A58.83,58.83,0,0,0,125.3,396c-.14-.08-.27.14-.13.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,313.66s-6.57,17.55-7.12,26.32c-.91,14.55,6.3,54.86,6.3,54.86s-2.47,39.51-4.61,45.37-1.25,11.26-11,13.25c-2.63.54-7.22,9.07-7.22,13.3h27.27s7.38-8.34,7.73-16.14,13.33-50.18,13.33-50.18",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.15,400.44s0,.11-.08.32-.15.54-.27.94c-.24.83-.59,2.05-1.05,3.62-.93,3.2-2.27,7.85-4,13.75s-3.71,13.1-5.75,21.38c-.51,2.07-1,4.21-1.44,6.43q-.15.83-.3,1.68c-.1.56-.14,1.13-.21,1.7l-.18,1.76c-.1.59-.2,1.18-.35,1.77a35.2,35.2,0,0,1-7.28,13.12l-.06.08h-.11l-27.27,0h-.26v-.25a19.11,19.11,0,0,1,2.33-7.54,25.2,25.2,0,0,1,2.11-3.46,12.37,12.37,0,0,1,1.36-1.55,3.85,3.85,0,0,1,1.86-1.06c2.6-.57,5.31-1.54,7-3.66s2.18-5,3-7.7c.14-.51.32-1,.49-1.51s.27-1,.41-1.48c.2-1,.42-2,.56-3,.32-2,.57-4.08.8-6.11.47-4.06.83-8.07,1.18-12,.68-7.9,1.24-15.53,1.72-22.81v.06c-2.07-11.94-3.72-23-4.89-33-.58-5-1-9.67-1.26-14a47.52,47.52,0,0,1,.51-12c.69-3.59,1.58-6.75,2.38-9.49s1.58-5.05,2.22-6.93,1.17-3.3,1.52-4.27l.42-1.09c.1-.25.16-.37.16-.37l-.12.38c-.09.27-.22.63-.38,1.11-.33,1-.82,2.43-1.45,4.29s-1.35,4.21-2.14,6.95-1.65,5.9-2.32,9.48a47.45,47.45,0,0,0-.44,12c.24,4.36.71,9,1.31,14,1.19,9.94,2.87,21,5,33v.06c-.47,7.29-1,14.92-1.69,22.82-.34,3.95-.71,8-1.17,12-.24,2-.49,4.08-.81,6.13-.14,1-.36,2.05-.56,3.08-.15.51-.28,1-.43,1.54s-.34,1-.48,1.48c-.4,1.35-.72,2.72-1.15,4.08a11.43,11.43,0,0,1-1.93,3.79,9.66,9.66,0,0,1-3.37,2.56,18.15,18.15,0,0,1-4,1.29,3.26,3.26,0,0,0-1.62.93,11.48,11.48,0,0,0-1.3,1.48,24.41,24.41,0,0,0-2.06,3.38,18.66,18.66,0,0,0-2.29,7.31l-.25-.25,27.27,0-.17.07a34.82,34.82,0,0,0,7.21-12.92c.14-.57.25-1.15.35-1.72l.18-1.73c.07-.58.12-1.17.21-1.74s.21-1.13.32-1.69c.44-2.22.95-4.37,1.46-6.44,2.07-8.29,4.15-15.45,5.86-21.37s3.13-10.54,4.1-13.71c.49-1.56.86-2.77,1.12-3.61l.3-.92A2.63,2.63,0,0,1,150.15,400.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,331.9s.1.21.27.64l.72,1.92c.63,1.7,1.54,4.19,2.72,7.39,2.33,6.43,5.7,15.73,9.61,27.32,1,2.9,2,5.94,2.95,9.14.5,1.59,1,3.23,1.43,4.91a44.42,44.42,0,0,1,.91,5.24c.87,7.15,1.28,14.83,1.74,22.9s.84,16.55,1.43,25.32c.31,4.38.63,8.85,1.25,13.33.16,1.12.34,2.25.59,3.35A12.45,12.45,0,0,0,222,455a3.08,3.08,0,0,0,.36.7c.07.08.15.18.22.2a3.33,3.33,0,0,0,.37.14,11,11,0,0,1,3.19,1.52,9.37,9.37,0,0,1,1.36,1.16,8.48,8.48,0,0,1,1.07,1.45,10.13,10.13,0,0,1,1,7l0,.2h-.21l-30.49,0h-.26v-.25a36.59,36.59,0,0,1,1.15-7.54c.58-2.43,1.24-4.8,2-7.12v.1c-1.84-12-3.58-23.11-5.21-33-.83-4.94-1.6-9.59-2.46-13.87-.12-.53-.21-1.07-.35-1.58l-.2-.76a4.82,4.82,0,0,0-.31-.7,17.44,17.44,0,0,0-1.71-2.52c-1.22-1.58-2.49-3-3.69-4.39-4.87-5.44-8.93-9.55-11.69-12.38l-3.18-3.23-.81-.83c-.19-.19-.27-.29-.27-.29l.29.26.85.8q1.11,1.11,3.23,3.18c2.79,2.8,6.89,6.88,11.8,12.29,1.21,1.37,2.49,2.8,3.73,4.4a16.57,16.57,0,0,1,1.75,2.57,4.53,4.53,0,0,1,.34.74l.2.78c.15.52.24,1.05.36,1.59.89,4.29,1.67,8.93,2.51,13.88,1.67,9.89,3.44,21,5.29,33v.11c-.71,2.31-1.37,4.67-1.94,7.09a37.06,37.06,0,0,0-1.13,7.43l-.25-.25,30.49-.06-.26.2a9.56,9.56,0,0,0-1-6.59,8.81,8.81,0,0,0-1-1.36,9.38,9.38,0,0,0-1.28-1.08,10.38,10.38,0,0,0-3-1.45,4.67,4.67,0,0,1-.44-.17A1,1,0,0,1,222,456a3.08,3.08,0,0,1-.43-.82,11.89,11.89,0,0,1-.5-1.68c-.26-1.13-.44-2.26-.6-3.39-.62-4.52-.94-9-1.25-13.38-.58-8.78-1-17.26-1.4-25.33s-.84-15.74-1.68-22.87a45.3,45.3,0,0,0-.89-5.19q-.67-2.51-1.41-4.9c-1-3.19-2-6.23-2.92-9.13-3.86-11.6-7.18-20.92-9.45-27.37-1.14-3.21-2-5.71-2.63-7.43-.29-.83-.52-1.48-.67-1.93S197.9,331.9,197.9,331.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.27,424a3.84,3.84,0,0,1-.56-.43l-1.53-1.3c-1.3-1.16-3.14-2.9-5.27-5.18a182.46,182.46,0,0,1-15.27-19,180.12,180.12,0,0,1-12.8-20.72c-1.43-2.78-2.45-5.09-3.1-6.71-.28-.78-.51-1.4-.69-1.88a4,4,0,0,1-.21-.67,3.35,3.35,0,0,1,.31.63l.78,1.84c.71,1.59,1.77,3.87,3.24,6.62a200.42,200.42,0,0,0,12.9,20.59,202.59,202.59,0,0,0,15.11,19c2.09,2.31,3.88,4.08,5.14,5.28l1.46,1.37A4.19,4.19,0,0,1,171.27,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,420.17a88.47,88.47,0,0,1,3.65,18.16,2.57,2.57,0,0,0,2.5,2.5,2.51,2.51,0,0,0,2.5-2.5,94.57,94.57,0,0,0-3.83-19.49,2.5,2.5,0,0,0-4.82,1.33Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,317.68c-.85-21.39-2.39-46.36-.06-54.5s18.7-24.22,28.11-28,25,1.24,29.7,5.41L213,233.47s5.81,13.47-1.35,24.27-28.28,10.68-28.28,10.68-1.89,11.75,7.14,12.78,21.05-.38,22.2,9.44l-18.55,1.66,1,16.36-35.3,18.76-33.05-9.54",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,248.21a3.15,3.15,0,0,1,.19.89l.37,2.58c.3,2.37.7,5.58,1.2,9.49s1,8.83,1.65,14.1a75.91,75.91,0,0,1,.66,8.4,23,23,0,0,1-1.49,9,12.21,12.21,0,0,1-6.32,6.55,14.25,14.25,0,0,1-8.48.75,15.22,15.22,0,0,1-6.9-3.41,17.53,17.53,0,0,1-4-5.35,22,22,0,0,1-2.23-9.34,20.38,20.38,0,0,1,.09-2.61,3.13,3.13,0,0,1,.16-.9c.08,0-.05,1.25.09,3.49a23,23,0,0,0,2.45,9.07,17.2,17.2,0,0,0,4,5.08,14.61,14.61,0,0,0,6.59,3.17,13.46,13.46,0,0,0,8-.75,11.32,11.32,0,0,0,5.85-6.1,22.47,22.47,0,0,0,1.44-8.64,81,81,0,0,0-.6-8.31c-.55-5.29-1.05-10.07-1.47-14.13s-.68-7.15-.91-9.53c-.08-1-.15-1.9-.21-2.59A3.92,3.92,0,0,1,151,248.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17,235.73a6.21,6.21,0,0,0,1.62,4.33,8.62,8.62,0,0,0,3.83,2.18,8.16,8.16,0,0,0,5.67.18,23,23,0,0,0-1.1-7,2.66,2.66,0,0,0-1.22-1.74,2.52,2.52,0,0,0-1.22-.12,19.06,19.06,0,0,0-7.58,2.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.94,283.74c.8,5.29,2.26,11.08,5.87,15s9.3,6.26,14.46,4.88c6.35-1.7,10.27-8.45,10.78-15s-1.68-13-3.84-19.18c1,5.91,2.07,12,.68,17.84s-5.83,11.37-11.78,12.08A13.09,13.09,0,0,1,131,294.8a19,19,0,0,1-5.08-11.06"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.39,244.76a5,5,0,0,1,0,1.55,26.75,26.75,0,0,1-.67,4.17,28.17,28.17,0,0,1-2.14,5.9,17.81,17.81,0,0,1-4.77,6.08,24.4,24.4,0,0,1-6.79,3.65,37.18,37.18,0,0,1-6.05,1.63,33.48,33.48,0,0,1-4.18.53,4.74,4.74,0,0,1-1.54,0c0-.14,2.17-.32,5.59-1.12a43.22,43.22,0,0,0,5.89-1.78,25.26,25.26,0,0,0,6.53-3.58,17.84,17.84,0,0,0,4.59-5.75,31,31,0,0,0,2.26-5.69C215.08,246.94,215.23,244.75,215.39,244.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.23,249.24a2.72,2.72,0,1,0,.19-.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,252.41c-.33.13-.88-.3-1.29-1.24a6.6,6.6,0,0,1-.3-3.93,6.5,6.5,0,0,1,1.89-3.45c.76-.69,1.44-.86,1.69-.61.51.56-.52,2.33-1,4.62S162.74,252.11,162,252.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.86,427.35c0,.06-1,0-2.87.09a23.76,23.76,0,0,0-3.33.39,13.2,13.2,0,0,0-4.13,1.49c-2.87,1.59-5.66,4.44-8.86,7.39s-6.09,6.9-10.25,9.89a16.27,16.27,0,0,1-6.83,2.9c-2.39.39-4.7.34-6.87.51a14.29,14.29,0,0,0-5.88,1.48,11.32,11.32,0,0,0-3.92,3.52,12.3,12.3,0,0,0-2.26,7.27,19.89,19.89,0,0,0,.37,2.83,8.43,8.43,0,0,1-.57-2.82,12.17,12.17,0,0,1,2.16-7.49,11.59,11.59,0,0,1,4-3.69,14.56,14.56,0,0,1,6.05-1.57c2.2-.19,4.5-.16,6.82-.54a16,16,0,0,0,6.62-2.82c4.07-2.93,7-6.81,10.22-9.81s6-5.77,9-7.38a13.7,13.7,0,0,1,4.26-1.45,21.51,21.51,0,0,1,3.37-.3c.93,0,1.65,0,2.14.05A4.89,4.89,0,0,1,198.86,427.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,457.82a3,3,0,0,1,.92-.08,11.81,11.81,0,0,1,2.49.3,13.37,13.37,0,0,1,10.44,11.67,11.71,11.71,0,0,1,0,2.51,2.75,2.75,0,0,1-.18.9c-.1,0,.11-1.31-.2-3.37a13.69,13.69,0,0,0-10.17-11.35C162.93,457.86,161.61,457.92,161.62,457.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.49,471a5.75,5.75,0,0,1-.74,2.28,10.64,10.64,0,0,1-9.47,5.83,5.41,5.41,0,0,1-2.37-.37c0-.08.91.09,2.35,0a11.22,11.22,0,0,0,9.16-5.64C171.15,471.85,171.4,471,171.49,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.86,464.55c0,.08-.8.24-2,.75a11.81,11.81,0,0,0-6.73,7.27c-.42,1.25-.51,2.07-.6,2.06a5.34,5.34,0,0,1,.25-2.17,10.91,10.91,0,0,1,7-7.51A4.94,4.94,0,0,1,162.86,464.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81,467.69a13.25,13.25,0,0,1,.21-2,11,11,0,0,0-.43-4.77,6.26,6.26,0,0,0-3.09-3.46,9.38,9.38,0,0,0-1.92-.52,3,3,0,0,1,2.07.18,6.2,6.2,0,0,1,3.43,3.62,9.79,9.79,0,0,1,.3,5A5.87,5.87,0,0,1,219.81,467.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,456.23c0,.09-.93,0-2.37.19a10.84,10.84,0,0,0-5.14,2.21,11,11,0,0,0-3.29,4.54c-.52,1.36-.61,2.28-.7,2.27a5.39,5.39,0,0,1,.36-2.4,10.09,10.09,0,0,1,8.72-7A5.35,5.35,0,0,1,121.07,456.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,447.11s.48-.63,1.24-1.83a22.39,22.39,0,0,0,2.48-5.42,26.86,26.86,0,0,0,1.1-8.76,27.26,27.26,0,0,0-2.5-10.47,20.45,20.45,0,0,0-6.82-8.22,21.27,21.27,0,0,0-8-3.51,13.58,13.58,0,0,0-5.91.11,13.28,13.28,0,0,0-1.54.54,2,2,0,0,1-.54.19,2.27,2.27,0,0,1,.5-.29,8.74,8.74,0,0,1,1.52-.63,12.93,12.93,0,0,1,6-.28,21,21,0,0,1,8.26,3.47,19.71,19.71,0,0,1,3.95,3.57,22.94,22.94,0,0,1,3.07,4.83,27.18,27.18,0,0,1,2.51,10.68,26.29,26.29,0,0,1-1.23,8.88A21.15,21.15,0,0,1,247,445.4c-.42.58-.76,1-1,1.3A2.71,2.71,0,0,1,245.57,447.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.58,396a20.2,20.2,0,0,0-13.78,1.75,20.83,20.83,0,0,0-6.94,5.61,13.8,13.8,0,0,0-2.26,4,23.5,23.5,0,0,0-1,4.21,47.66,47.66,0,0,0-.43,7.39c0,2.11.08,3.82.11,5,0,.54,0,1,0,1.36a1.52,1.52,0,0,1,0,.48,1.62,1.62,0,0,1-.07-.47c0-.38-.07-.82-.11-1.36-.09-1.19-.21-2.9-.28-5a45.24,45.24,0,0,1,.33-7.46,23,23,0,0,1,1-4.31,14.14,14.14,0,0,1,2.33-4.17,20.85,20.85,0,0,1,7.14-5.71,21.15,21.15,0,0,1,7.18-2.07,16.81,16.81,0,0,1,5,.24,9.88,9.88,0,0,1,1.33.34A1.91,1.91,0,0,1,124.58,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,374.31a4.06,4.06,0,0,1-.26-1.09,25.79,25.79,0,0,1-.36-3,36.67,36.67,0,0,1,4.13-19.53A24.33,24.33,0,0,1,88.4,348a4.42,4.42,0,0,1,.67-.9c.08.05-.79,1.39-1.91,3.69a40.84,40.84,0,0,0-4.08,19.35C83.17,372.73,83.42,374.3,83.33,374.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,375.87a4.72,4.72,0,0,1-.29-1.09c-.17-.7-.34-1.74-.51-3a46.39,46.39,0,0,1,1.94-20c.41-1.23.78-2.21,1.08-2.87a4.79,4.79,0,0,1,.49-1c.09,0-.5,1.53-1.22,4a53.3,53.3,0,0,0-1.92,19.89C79.92,374.28,80.21,375.86,80.12,375.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.35,415.52a37.72,37.72,0,0,1,8.66,16.1,6.43,6.43,0,0,1,.05,4c-1.15,2.7-4.86,2.82-7.39,4.28-2.13,1.22-3.44,3.44-4.66,5.57l-12.4,21.56c3.83-.32,5.25.08,9.08-.23l6.16.13c-.23.1-1.2-2.93-1.28-4.35-.25-4.34,2.68-9.59,6.58-11.52,4.89-2.43,10.52-.4,15.49-2.68,4.75-2.19,7.58-5.53,10.67-8.59,3.88-3.85,7.73-9,12.7-11.23,2.25-1,7.62-1.12,7.62-1.12-2.55-3-7.23-2.85-11-1.83s-7.71,2.69-11.56,1.82c-3.23-.72-5.8-3.11-8.19-5.4-6.13-5.86-12.47-12-15.21-20.07l-5.11,13.21"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.35,467.05c2-4.86-2.54-10.6-4.36-15.52s-1.44-10.48-1.43-15.79a102.68,102.68,0,0,0-5.36-33c-.4,14.58,1.27,30.06,2.14,44.61.18,3.09-.06,6.66,2.21,8.76,1.16,1.08,1.85.61,3.15,1.51s3.85,3,3.65,9.4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M170.46,323.43a14.8,14.8,0,0,1-8.46-7.68,46.84,46.84,0,0,0,3.81,4.3A44,44,0,0,0,170.46,323.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.21,321.38a15.49,15.49,0,0,1-8-5.64c.12-.1,1.63,1.49,3.84,3S174.27,321.23,174.21,321.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.15,321.2a10,10,0,0,1-4.33-1.9,10.17,10.17,0,0,1-3.37-3.31c.12-.11,1.53,1.45,3.66,2.88S179.2,321.05,179.15,321.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.14,364.15a12.13,12.13,0,0,1-4.66-3.55,11.94,11.94,0,0,1-2.87-5.09,42.15,42.15,0,0,0,3.27,4.75A43.49,43.49,0,0,0,145.14,364.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,364.2a15.15,15.15,0,0,1-6.19-7.48c.14-.07,1.17,1.86,2.88,3.92S148.92,364.08,148.83,364.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.26,365.45a23.4,23.4,0,0,1-3.54-3.42,23.12,23.12,0,0,1-3.16-3.78,23.8,23.8,0,0,1,3.54,3.43A23.31,23.31,0,0,1,155.26,365.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.42,282.23s-.45-.18-1-.72A6.78,6.78,0,0,1,133,279a6.89,6.89,0,0,1-.35-2.87c.08-.74.26-1.17.32-1.16a15,15,0,0,0,.52,3.86A14.37,14.37,0,0,0,135.42,282.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,281.46a5.28,5.28,0,0,1-1.51-2.66,5.38,5.38,0,0,1-.27-3.05c.16,0,.28,1.34.77,2.89S137.3,281.38,137.18,281.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.15,284a14.65,14.65,0,0,1-3.48-7.7c.15,0,.68,1.78,1.64,3.89S141.27,283.86,141.15,284Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.92,99.35c-7.75,4.75-10.38,16.22-10.71,25.3s2.14,18,4.15,26.87,3.56,18.16,1.38,27c-2,8.18-7.12,16.8-3.45,24.38,2.77,5.72,9.86,8.69,11.82,14.74,2.28,7.06-3.49,14-8.79,19.15a9.33,9.33,0,0,0,12.11,3.13,7.82,7.82,0,0,1-2.86,5.57,16.24,16.24,0,0,0,16.59-5.79c-.73,2.52-1.47,5-2.2,7.56a24.05,24.05,0,0,0,14.74-10.46l2.55,4.78c9.75-6.7,16.53-17.24,19.86-28.6s3.36-23.49,1.45-35.17a110,110,0,0,0-56.64-78.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,182.63c-3.47-4.17-7.75-8.31-8.23-13.72-.21-2.38.36-4.83-.18-7.17-1.4-6-9.24-8.41-11.6-14.13-3-7.18,3.78-16.68-1.22-22.63-2.4-2.85-6.53-3.41-9.68-5.4-8-5.07-6.06-19-25.25-29.14l1.43,30.62A781.8,781.8,0,0,1,333,199.59l43.31-2.14C378.78,192.63,375.82,186.8,372.34,182.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75,110.51a28.8,28.8,0,0,1,9.84-20c6.35-5.48,14.92-7.92,23.3-8s16.67,1.91,24.65,4.49c4.48,1.45,9,3.13,12.63,6.12,6.64,5.45,9.28,14.26,11.59,22.53,1.86,6.69,3.74,13.72,2.2,20.49a21.36,21.36,0,0,1-11.6,14.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.07,104.75A39.53,39.53,0,0,0,259,153.58a332.46,332.46,0,0,1,5.69-57.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31,131.31c-2-13.53,3.37-31.8,17-33.22l32.45,1.23c10.41.4,18.78,7.32,21.69,17.32.14.5.06-.13.13.26L336.66,198a24.62,24.62,0,0,1-19.56,28.63h0a24.6,24.6,0,0,1-28.7-19c-1.41-6.49-3.06-14.15-3.06-14.11s-17.66.79-25.93-20.71C255.3,162.11,252.53,146.34,250.31,131.31Z",
    style: {
      fill: "#9d6054"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.39,117.77a33.06,33.06,0,0,1-12.75,4.13c0-.16,2.9-.8,6.41-1.94S279.32,117.63,279.39,117.77Z",
    style: {
      fill: "#724a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.25,118.05a16.28,16.28,0,0,1-8,2.17,28.37,28.37,0,0,1,4-1.11A28.17,28.17,0,0,1,274.25,118.05Z",
    style: {
      fill: "#724a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,160.1c-.14.05-.53-.81-1.55-1.19s-1.88,0-1.95-.19.14-.26.54-.4a2.32,2.32,0,0,1,1.61.07,2.39,2.39,0,0,1,1.23,1.05C293.06,159.82,293.05,160.09,293,160.1Z",
    style: {
      fill: "#724a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,147.68a2.92,2.92,0,0,0,3.37,2.29,2.78,2.78,0,0,0,2.39-3.2,2.91,2.91,0,0,0-3.36-2.29A2.8,2.8,0,0,0,259,147.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.26,139.91c.43.3,2.25-1.76,5.33-2.41s5.65.41,5.9,0c.13-.2-.37-.8-1.51-1.31a8.07,8.07,0,0,0-4.82-.43,7.74,7.74,0,0,0-4.14,2.38C256.23,139,256.05,139.78,256.26,139.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.59,141.65A2.93,2.93,0,0,0,290,144a2.79,2.79,0,0,0,2.39-3.2,2.92,2.92,0,0,0-3.36-2.3A2.79,2.79,0,0,0,286.59,141.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.57,134.06c.44.3,2.26-1.76,5.33-2.41s5.65.42,5.91,0c.12-.2-.38-.8-1.51-1.3a8,8,0,0,0-4.83-.44,7.69,7.69,0,0,0-4.14,2.39C286.54,133.19,286.36,133.93,286.57,134.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.27,159.21c0-.18-2-.1-5.18.16-.8.09-1.58.09-1.82-.42a4,4,0,0,1,0-2.43c.33-2.06.68-4.21,1.05-6.47,1.41-9.19,2.25-16.68,1.88-16.73s-1.81,7.35-3.23,16.54q-.5,3.39-.94,6.48a4.64,4.64,0,0,0,.25,3.17,2,2,0,0,0,1.53.87,5.67,5.67,0,0,0,1.37-.1C278.36,159.79,280.3,159.39,280.27,159.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.15,179.26s-4,16.83-26.68,19.49l-1.13-5.23A57.35,57.35,0,0,0,313.15,179.26Z",
    style: {
      fill: "#724a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.14,166.34a5.66,5.66,0,0,1,4.53-3.11,5.16,5.16,0,0,1,3.89,1.13,3.28,3.28,0,0,1,1,3.61,3.79,3.79,0,0,1-3.81,1.87,11.78,11.78,0,0,1-4.43-1.51,3.54,3.54,0,0,1-1.07-.72,1.06,1.06,0,0,1-.24-1.14",
    style: {
      fill: "#724a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.76,159.41c-.5.08.2,3.42-2.15,6.39s-6,3.36-5.91,3.83c0,.22.93.48,2.44.2a8.48,8.48,0,0,0,5-3,7.38,7.38,0,0,0,1.59-5.31C290.53,160.09,290,159.35,289.76,159.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9,125.23c.48.77,3.46-.28,7.16-.61s6.82,0,7.14-.82c.13-.4-.54-1.08-1.89-1.64a12.5,12.5,0,0,0-10.89,1.09C284.21,124.06,283.69,124.86,283.9,125.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.5,130.78c.69.58,2.65-.59,5.19-1.17s4.79-.53,5.14-1.36c.14-.4-.35-1-1.43-1.49a7.72,7.72,0,0,0-8.32,2C255.33,129.71,255.19,130.49,255.5,130.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,109.69c.64-3.64,3.88-6.44,7.45-7.4s7.39-.35,10.91.79c14.89,4.81,25.61,18.41,40.4,23.52,3.64,1.26,7.52,2,10.81,4s6,5.74,5.18,9.51a31.66,31.66,0,0,0,2.89-8.66,10.72,10.72,0,0,0-2.23-8.59c-1.55-1.72-3.87-2.79-4.9-4.87-.9-1.83-.57-4-1.08-6a13.23,13.23,0,0,0-3.26-5.24c-7.07-8-15.89-14.65-26.07-17.8a38.42,38.42,0,0,0-20.61-.85,29.38,29.38,0,0,0-17,11.37c-2.34,3.35-4.82,6.84-2.5,10.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.21,143.47c-.58-.15-.64-1.67-1.08-4.07a11.6,11.6,0,0,0-1.31-3.81,6.06,6.06,0,0,0-.6-.81,3.64,3.64,0,0,0-.34-.34l-.48-.44a18.89,18.89,0,0,0-2.29-1.74,5.76,5.76,0,0,0-2.21-.93c-.26,0-.3.06-.18.07l-.75.32-.8.38a14.76,14.76,0,0,0-2.9,1.87c-.47.38-.93.8-1.4,1.25l-.35.35-.6.56a14.7,14.7,0,0,1-1.27,1,14.52,14.52,0,0,1-6,2.4,10.67,10.67,0,0,1-3.95-.13l-.54-.14-.43-.15c-.28-.1-.58-.19-.85-.31a14.4,14.4,0,0,1-1.62-.81,18.55,18.55,0,0,1-4.93-4.38C299,132,298,130.43,297,129a60.22,60.22,0,0,0-12.93-13.64,64.87,64.87,0,0,0-13.38-7.94,36.79,36.79,0,0,0-9.85-3.14c-2.39-.35-3.89-.26-4.1-.84s1-1.72,3.9-2.43,7.23-.52,12,.8a52.94,52.94,0,0,1,15.94,7.26,57,57,0,0,1,15.35,15.17c1,1.54,2,2.93,2.88,4.09a11.47,11.47,0,0,0,2.67,2.57,5,5,0,0,0,.63.35,3.09,3.09,0,0,0,.32.14l.15.06.07,0a2.33,2.33,0,0,0,1,.08,7.12,7.12,0,0,0,2.85-1c.22-.13.42-.26.61-.39l.27-.2.49-.42c.67-.56,1.37-1.09,2.09-1.58a20.82,20.82,0,0,1,4.57-2.34c.38-.13.75-.26,1.12-.37l.54-.17.63-.17a6.62,6.62,0,0,1,3.7.08,11.38,11.38,0,0,1,4.27,2.53,19.49,19.49,0,0,1,2.62,2.85c.19.25.34.44.54.75a7.75,7.75,0,0,1,.55.9,10,10,0,0,1,.73,1.76,12,12,0,0,1,.22,5.62C336.81,142.34,335.74,143.62,335.21,143.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,134c.1-.69,10.81-7.37,13.61,4.93,2.73,12-9.87,12.19-10,11.86S322.75,134,322.75,134Z",
    style: {
      fill: "#9d6054"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.06,145.41c.05,0,.24.1.63.18a2.17,2.17,0,0,0,1.57-.32c1.15-.75,1.77-3,1.34-5.16a6.93,6.93,0,0,0-1.25-2.85,2.46,2.46,0,0,0-1.93-1.25,1.1,1.1,0,0,0-1.1.85c-.09.37,0,.59,0,.62s-.31-.14-.32-.65a1.38,1.38,0,0,1,.3-.86,1.61,1.61,0,0,1,1.08-.56,3,3,0,0,1,2.6,1.36,7.21,7.21,0,0,1,1.47,3.17c.46,2.43-.26,5-1.88,5.85a2.29,2.29,0,0,1-2,.11C329.15,145.69,329,145.44,329.06,145.41Z",
    style: {
      fill: "#724a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.51,220.92a19.66,19.66,0,0,0-10.6,11c-3.31,8.38-17.69,59.39-17.69,59.39l-30,3.85-2.27,27.72a159.49,159.49,0,0,0,26.46,4.56c11.06,1,28.94-.65,33.6-3.26s-.46-102.07-.46-102.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.59,213.35c9.5,10.79,34.46-11.09,45.57-28.48L298.42,352.72l-6.1-1.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.85,206l-2.3,10.9L277,224.64c-.11,14.24,7.59,42.68,5.67,48.38-2.73,8.15-3.82,16.59-.55,28.47,1.67,6.08,11.78,49.74,11.78,49.74S291,465.48,291.32,467h23.24L291.87,315,291,219.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,394.56c-7.2-18-33.83-64.06-33.83-64.06s-2.16-16.19-4-51.82S381.88,203.11,378.64,197s-39.24-12.12-39.24-12.12l-6.3-9.17S319.68,211,319,212s-15.09,43.36-16.53,55.24S297,343.1,297,343.1L314.56,467H445.48S444.14,412.55,436.94,394.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.67,390.08l65.12-7.35.23,0,0,.23c1.85,19.93,4,43.59,6.4,68.88.26,2.79.51,5.55.77,8.3l0,.27H388l-52.35,1.2h-.18l-.05-.18c-5.8-21.24-10.67-39.09-14.1-51.64-1.74-6.25-3.11-11.18-4.06-14.56l-1.11-3.84-.31-1c-.08-.22-.13-.32-.12-.32a1.89,1.89,0,0,1,.16.31c.08.22.2.54.34,1,.29.86.68,2.14,1.18,3.82,1,3.35,2.42,8.27,4.19,14.53,3.53,12.51,8.47,30.34,14.28,51.59l-.23-.17,52.35-1.26-.25.29q-.37-4.12-.77-8.3c-2.32-25.3-4.49-49-6.32-68.89l.24.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.32,399.25c0,.14-14,1.28-31.22,2.54s-31.25,2.17-31.26,2,14-1.28,31.22-2.54S382.31,399.1,382.32,399.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.63,330.31a3.48,3.48,0,0,1-.77.5c-.51.29-1.28.68-2.24,1.12a35.27,35.27,0,0,1-7.88,2.5,42.57,42.57,0,0,1-8.23.68c-1.06,0-1.91-.05-2.5-.1a3.24,3.24,0,0,1-.91-.12,29.63,29.63,0,0,1,3.4-.15,53.78,53.78,0,0,0,8.15-.82,42.57,42.57,0,0,0,7.83-2.33A33.49,33.49,0,0,1,402.63,330.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.11,330.5a17.31,17.31,0,0,1-2.22,2.3c-1.43,1.36-3.46,3.18-5.74,5.14l-5.83,5a24.48,24.48,0,0,1-2.46,2,15.87,15.87,0,0,1,2.22-2.3c1.43-1.36,3.46-3.18,5.73-5.15l5.83-5A22.24,22.24,0,0,1,403.11,330.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.62,427.34c-2.51-.91-5.25-1.27-7.57.06a5.7,5.7,0,0,0-2.52,5.55,9.62,9.62,0,0,0,3,5.59,6,6,0,0,0,3.79,2,6.3,6.3,0,0,0,4.35-2,10.19,10.19,0,0,0,2.88-4,5.46,5.46,0,0,0-.45-4.81c-1.08-1.6-3.06-2.3-4.91-2.9",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,426a5.33,5.33,0,0,0-.33-3.16,3.59,3.59,0,0,0-2.36-2,2.76,2.76,0,0,0-2.87,1,3.17,3.17,0,0,0-.45,2.22,3.86,3.86,0,0,0,2.34,3.15,3,3,0,0,0,3.67-1.19",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.25,426.52a5.34,5.34,0,0,0,3-1,3.63,3.63,0,0,0,1.51-2.72,2.78,2.78,0,0,0-1.56-2.61,3.25,3.25,0,0,0-2.28,0,3.87,3.87,0,0,0-2.61,2.92,3,3,0,0,0,1.91,3.36",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.71,430a3.7,3.7,0,0,0,2.09-.66,2.51,2.51,0,0,0,1-1.88,1.9,1.9,0,0,0-1.08-1.8,2.23,2.23,0,0,0-1.57,0,2.68,2.68,0,0,0-1.8,2,2.1,2.1,0,0,0,1.32,2.32",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.12,424.69a6.33,6.33,0,0,0,2.9-2.38,4.29,4.29,0,0,0,.47-3.65,3.28,3.28,0,0,0-2.85-2.17,3.75,3.75,0,0,0-2.49,1,4.59,4.59,0,0,0-1.59,4.35,3.6,3.6,0,0,0,3.56,2.85",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.43,300a1,1,0,0,1,.07-.29c.06-.22.15-.5.25-.86.25-.78.59-1.88,1-3.27.92-2.88,2.24-7,3.88-12.05l13-39.93v0c.1-.7.21-1.45.31-2.21,1-6.77,1.88-13.28,2.74-19.33V222l.05,0,11.92-13.34-.05.11,2.66-17.39c.32-2,.58-3.64.76-4.77.09-.53.16-.94.21-1.25a2.9,2.9,0,0,1,.1-.42,2,2,0,0,1,0,.43c0,.31-.09.73-.15,1.25-.15,1.14-.37,2.75-.65,4.8-.6,4.18-1.45,10.14-2.48,17.41v.06l0,0-11.86,13.4.06-.13c-.85,6.05-1.76,12.56-2.71,19.33-.11.76-.21,1.52-.31,2.22v0c-5.18,15.63-9.83,29.69-13.2,39.88-1.7,5-3.07,9.14-4,12-.48,1.38-.85,2.47-1.12,3.24q-.18.53-.3.84C302.48,299.87,302.44,300,302.43,300Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.27,312.41a.51.51,0,0,1,0-.2c0-.16-.07-.35-.11-.59q-.14-.84-.36-2.28c-.31-2-.74-4.91-1.28-8.48-1.05-7.26-2.5-17.33-4.15-28.79V272c.36-2.87.74-5.85,1.12-8.9.67-5.21,1.31-10.22,1.9-14.91l.07.2L281,240.65l-.08-.09,0-.11,3.13-17.11c.39-2,.7-3.64.91-4.78.11-.52.2-.94.26-1.26a1.87,1.87,0,0,1,.11-.42,2,2,0,0,1,0,.43c-.05.33-.11.75-.19,1.27-.19,1.15-.46,2.77-.79,4.8-.72,4.18-1.74,10.07-3,17.15l-.05-.19,7.46,7.71.08.08v.12c-.59,4.69-1.23,9.71-1.88,14.92-.39,3-.77,6-1.13,8.89V272l4,28.82c.48,3.58.86,6.47,1.13,8.51.11,1,.21,1.73.27,2.29l.07.59Q291.28,312.41,291.27,312.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.54,466.84c-.14,0-3.68-24.07-7.91-53.81s-7.54-53.88-7.4-53.9,3.69,24.08,7.91,53.83S314.68,466.82,314.54,466.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "232 335.67 252.23 329.85 264.81 359.13 236.63 358.25 232 336.86",
    style: {
      fill: "#9d6054"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.23,329.85l16.45,38.3s82.24-23.47,88.12-30.06,18.32-66,20.44-77.55,4.46-58.33-5.41-65.82-19.5-5.85-28.9,4.49c-7.61,8.37-20,56.29-24.45,74.19a38,38,0,0,0-.86,13.48l.87,7.49s-7.75,7.05-8.22,13.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,224.76s-.1.42-.31,1.23-.55,2-1,3.6c-.87,3.16-2.14,7.81-3.78,13.78l-6,21.74c-.59,2.11-1.19,4.3-1.82,6.56a36.48,36.48,0,0,0-1.39,7.06,37.23,37.23,0,0,0,0,7.61q.47,3.92.94,8v.1l-.07.07a36.08,36.08,0,0,0-5.09,6,16.6,16.6,0,0,0-3.06,7.54v.13l-.12.05-58,21.89.14-.33,16.46,38.29-.31-.14c6.78-2,14-4.06,21.21-6.24,14.12-4.24,27.88-8.5,41.05-13,6.58-2.25,13-4.5,19.17-7.14,1.53-.65,3-1.36,4.47-2.15a10.79,10.79,0,0,0,2-1.37,5.49,5.49,0,0,0,.72-.93c.2-.35.41-.69.59-1.05a67.15,67.15,0,0,0,3.44-9c1.92-6.09,3.52-12.11,5-18s2.85-11.58,4.12-17.12c2.53-11.08,4.77-21.43,6.6-30.91a254.65,254.65,0,0,0,3.3-25.85,134.32,134.32,0,0,0,.23-19.66c-.42-5.38-1.36-9.52-2.63-12.07a9.59,9.59,0,0,0-2.55-3.45l.83.72c.25.27.53.63.87,1.05a13.59,13.59,0,0,1,.95,1.63c1.3,2.55,2.28,6.72,2.73,12.1a132,132,0,0,1-.14,19.7,251.2,251.2,0,0,1-3.23,25.89c-1.81,9.5-4,19.86-6.54,31-1.26,5.54-2.61,11.26-4.09,17.14s-3.09,11.9-5,18a67.57,67.57,0,0,1-3.45,9.1c-.19.37-.41.73-.61,1.09a6.39,6.39,0,0,1-.79,1,10.85,10.85,0,0,1-2.08,1.46c-1.46.8-3,1.52-4.51,2.18-6.17,2.65-12.62,4.91-19.2,7.17-13.18,4.47-26.94,8.74-41.07,13-7.26,2.18-14.44,4.29-21.22,6.23l-.22.07-.09-.21L252,330l-.1-.24.25-.09,58-21.82-.14.19a16.93,16.93,0,0,1,3.14-7.73,37,37,0,0,1,5.16-6l-.06.17q-.46-4.11-.92-8a37.89,37.89,0,0,1,0-7.68,36.81,36.81,0,0,1,1.43-7.12l1.83-6.55c2.37-8.45,4.41-15.75,6.08-21.72l3.88-13.75c.44-1.57.79-2.76,1-3.58S332,224.76,332,224.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,316.77a24.3,24.3,0,0,0-4.62-5.38,23.68,23.68,0,0,0-6.26-3.35,5.79,5.79,0,0,1,2.08.45,15,15,0,0,1,7.91,6.35A6,6,0,0,1,321,316.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.4,301.23c-.08.06-.83-1.11-2.43-2.63a18.1,18.1,0,0,0-15.85-4.73c-2.17.4-3.44,1-3.48.88a3.28,3.28,0,0,1,.87-.45,16,16,0,0,1,2.54-.79,17.35,17.35,0,0,1,16.18,4.82,15,15,0,0,1,1.69,2.06A3.52,3.52,0,0,1,339.4,301.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,371.41c-11.18,0-26.67-3.87-46.06-11.51-14.35-5.66-25.62-11.4-25.74-11.45l1.82-3.57c.44.23,44.42,22.53,70,22.53,10.1,0,17.92-4.88,23.23-14.5a47.68,47.68,0,0,0,5.11-15c.27-1.6,6.3-37.57,8.37-47.17,1.08-5,4-13.22,6.76-21.16,2.56-7.27,5.2-14.78,5.73-18,1.09-6.53.3-20.8.3-20.94l4-.23c0,.61.82,14.86-.34,21.82-.59,3.55-3.17,10.89-5.9,18.65s-5.6,15.92-6.63,20.68c-2,9.51-8.26,46.54-8.32,46.92S278.44,371.41,250.65,371.41Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250.65,371.41c-11.18,0-26.67-3.87-46.06-11.51-14.35-5.66-25.62-11.4-25.74-11.45l1.82-3.57c.44.23,44.42,22.53,70,22.53,10.1,0,17.92-4.88,23.23-14.5a47.68,47.68,0,0,0,5.11-15c.27-1.6,6.3-37.57,8.37-47.17,1.08-5,4-13.22,6.76-21.16,2.56-7.27,5.2-14.78,5.73-18,1.09-6.53.3-20.8.3-20.94l4-.23c0,.61.82,14.86-.34,21.82-.59,3.55-3.17,10.89-5.9,18.65s-5.6,15.92-6.63,20.68c-2,9.51-8.26,46.54-8.32,46.92S278.44,371.41,250.65,371.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,231.89a9.5,9.5,0,0,1-6.7-2.64c-6.89-6.83-14.23-35.2-14.54-36.4l1.93-.5c.08.29,7.52,29,14,35.48a7.68,7.68,0,0,0,6.63,1.95c3.26-.51,6.17-2.81,8-6.31,5.32-10.25,19.82-80.24,20-80.95l2,.41c-.6,2.89-14.7,71-20.15,81.46-2.11,4.07-5.56,6.76-9.45,7.37A10.19,10.19,0,0,1,299.48,231.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,148.28c.14-2.81-.54-5.09-1-7.86-.2-1.17.17-3.16,1.15-3.84s2.48.15,2.9,1.3a10,10,0,0,1,.19,4.12c-.45,3.32-1.39,4.29-1.93,6.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.47,232.45l-.62,0a12.3,12.3,0,0,1-10.51-6.8c-2.53-5-5.83-11.74-7.18-15.43l3.75-1.37c1,2.73,3.49,8.06,7,15a8.34,8.34,0,0,0,7.13,4.62,8.18,8.18,0,0,0,7.42-3.84l.11-.18c.08-.15.43-1,1.66-4.52l.14-.4c.72-2,2.23-6.54,4.25-14l3.86,1c-2.05,7.63-3.6,12.27-4.35,14.35l-.13.38c-1.52,4.32-1.79,4.92-2,5.25l-.16.26A12.17,12.17,0,0,1,300.47,232.45Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.47,232.45l-.62,0a12.3,12.3,0,0,1-10.51-6.8c-2.53-5-5.83-11.74-7.18-15.43l3.75-1.37c1,2.73,3.49,8.06,7,15a8.34,8.34,0,0,0,7.13,4.62,8.18,8.18,0,0,0,7.42-3.84l.11-.18c.08-.15.43-1,1.66-4.52l.14-.4c.72-2,2.23-6.54,4.25-14l3.86,1c-2.05,7.63-3.6,12.27-4.35,14.35l-.13.38c-1.52,4.32-1.79,4.92-2,5.25l-.16.26A12.17,12.17,0,0,1,300.47,232.45Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 172.56,
    cy: 343.04,
    r: 9.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.1,
    cy: 343.6,
    r: 5.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,352.72s-2.12-5,0-6.82,24.3-7.81,24.3-7.81,15.64-4.52,17.31-4.73,22,1.15,22,1.15,11.54-3.18,13.21-3.18-.76,10.62-1.06,14.12-2.58,5.59-.46,7.27,7.76,6.41,7.76,6.41-5.94,1.65-10,1.2a24.22,24.22,0,0,1-7-1.83s-8.35,6.23-12.91,7.14-19.73,5.92-22.77,5.47-5.31-4.56-5.31-4.56-7.14,1.06-8.51-1.82a25.26,25.26,0,0,1-1.82-5.16l2.89-1.83s-3.8,1.07-5.47-1.67a11.89,11.89,0,0,1-1.82-4.84S169,353.47,166.46,352.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.43,261.39a2.14,2.14,0,0,1-.09.58q-.13.64-.36,1.65c-.16.71-.36,1.58-.54,2.6s-.44,2.18-.6,3.48-.41,2.7-.55,4.23-.28,3.16-.4,4.88a87.66,87.66,0,0,0,1.71,22.32c.38,1.69.72,3.29,1.14,4.77s.8,2.85,1.19,4.1.79,2.36,1.13,3.34.65,1.81.93,2.49.45,1.16.6,1.57a2,2,0,0,1,.18.57,3.61,3.61,0,0,1-.27-.53l-.7-1.53c-.3-.67-.66-1.49-1-2.47s-.81-2.07-1.2-3.33-.87-2.61-1.26-4.1-.79-3.09-1.18-4.78a89.69,89.69,0,0,1-1.63-11.16,91.15,91.15,0,0,1-.1-11.28c.13-1.73.23-3.38.45-4.91s.39-2.95.61-4.24.48-2.46.69-3.48.43-1.88.63-2.59l.45-1.63A2.18,2.18,0,0,1,280.43,261.39Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeterinaryPana);
export default __webpack_public_path__ + "static/media/Veterinary-pana.0a564a414d271b4d9c2028fa00721ea5.svg";
export { ForwardRef as ReactComponent };